import { useState, type MouseEvent } from "react";
import { useLogin, useNotify, useTranslate } from "ra-core";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

export const GoogleOAuthButton = () => {
  const login = useLogin();
  const notify = useNotify();
  const translate = useTranslate();
  const [isPending, setIsPending] = useState(false);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsPending(true);
    login({ provider: "google" }).catch((error) => {
      setIsPending(false);
      notify(error?.message || "ra.auth.sign_in_error", { type: "error" });
    });
  };

  return (
    <Button
      className="w-full"
      type="button"
      onClick={handleClick}
      disabled={isPending}
    >
      {translate("crm.auth.sign_in_google", {
        _: "Continuar con Google",
      })}
      {isPending ? <Spinner className="size-4" data-icon="inline-end" /> : null}
    </Button>
  );
};
